import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const descriptionCss = {
  marginBottom: 10,
};

export const linksContainerCss = {
  display: "flex",
  flexWrap: "wrap",
  gap: 15,
  listStyleType: "none",
  padding: 0,
  margin: 0,
  a: {
    color: ui.core[700],
  },
};
